import { connect } from 'react-redux';
import { State } from 'store/types';
import View from './View';


const mapStateToProps = (state: State) => {
  const { searchListingPage } = state;

  return {
    content: searchListingPage.listingData?.seoData?.footerContent || '',
  };
};

export default connect(mapStateToProps)(View);
